import { render } from "./ipList.vue?vue&type=template&id=564e3d6c&scoped=true"
import script from "./ipList.vue?vue&type=script&lang=js"
export * from "./ipList.vue?vue&type=script&lang=js"

import "./ipList.vue?vue&type=style&index=0&id=564e3d6c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564e3d6c"]])

export default __exports__